module.exports = __webpack_public_path__ + "static/img/attention.29bd6f7.png";